import React, { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import DataTable from "../../../components/shared/DataTable";
import SearchInput from "../../../components/shared/SearchInput";
import Pagination from "../../../components/shared/Pagination";
import { statusBadgeClass, formatDate } from "../../../utils/helpers";
import api from "../../../utils/api";

export default function PatientList() {
  const queryClient = useQueryClient();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery(
    ["admin-patients", page, search],
    () => api.get(`/admin/patients?page=${page}&search=${search}`),
    { keepPreviousData: true }
  );
  const blockMutation = useMutation(
    ({ id, blocked }) => api.post(`/admin/patients/${id}/block`, { blocked }),
    {
      onSuccess: (_, { blocked }) => {
        queryClient.invalidateQueries("admin-patients");
        toast.success(blocked ? "Patient blocked" : "Patient unblocked");
      },
    }
  );

  const columns = [
    { key: "name", label: "Name", sortable: true },
    { key: "email", label: "Email" },
    { key: "phone", label: "Phone" },
    {
      key: "createdAt",
      label: "Registered",
      render: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      key: "totalBookings",
      label: "Total Bookings",
      sortable: true,
    },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <span className={statusBadgeClass(row.blocked ? "blocked" : "active")}>
          {row.blocked ? "Blocked" : "Active"}
        </span>
      ),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <button
          onClick={() =>
            blockMutation.mutate({ id: row.id, blocked: !row.blocked })
          }
          className={`text-xs px-3 py-1 rounded-lg transition-colors ${
            row.blocked
              ? "bg-green-100 text-green-700 hover:bg-green-200"
              : "bg-red-100 text-red-700 hover:bg-red-200"
          }`}
        >
          {row.blocked ? "Unblock" : "Block"}
        </button>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Search patients…"
        className="w-72"
      />
      <DataTable
        columns={columns}
        data={data?.data || []}
        loading={isLoading}
        emptyMessage="No patients found."
      />
      <Pagination
        page={page}
        totalPages={data?.pagination?.totalPages || 1}
        onPageChange={setPage}
      />
    </div>
  );
}
